
export default {
  state: {
    data: {
      report_filter: [],
      lotacao: [],
      categoria: []
    }
  },
  mutations: {
    updateReportSettings (state, report_settings) {
      state.data.report_filter = report_settings.report_filter
      state.data.lotacao = report_settings.lotacao
      state.data.categoria = report_settings.categoria
    },
    resetReportSettings (state) {
      state.data.report_filter = []
      state.data.lotacao = []
      state.data.categoria = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reportSettings.js